import React, { useEffect } from "react";
import confetti from "canvas-confetti";
import { siteData, images } from "../data/mock";
import { ArrowDown, MapPin, Calendar } from "lucide-react";

const fireSideCannons = () => {
  const colors = ["#FE3A80", "#ff5a96", "#9DA0A9", "#ffffff", "#fecad9"];
  const defaults = { startVelocity: 35, spread: 55, ticks: 70, zIndex: 50, colors };

  // Left cannon
  confetti({ ...defaults, particleCount: 40, angle: 60, origin: { x: 0, y: 0.6 } });
  // Right cannon
  confetti({ ...defaults, particleCount: 40, angle: 120, origin: { x: 1, y: 0.6 } });

  setTimeout(() => {
    confetti({ ...defaults, particleCount: 30, angle: 60, origin: { x: 0, y: 0.7 } });
    confetti({ ...defaults, particleCount: 30, angle: 120, origin: { x: 1, y: 0.7 } });
  }, 250);

  setTimeout(() => {
    confetti({ ...defaults, particleCount: 20, angle: 55, origin: { x: 0, y: 0.65 } });
    confetti({ ...defaults, particleCount: 20, angle: 125, origin: { x: 1, y: 0.65 } });
  }, 500);
};

export const HeroSection = () => {
  useEffect(() => {
    const timer = setTimeout(fireSideCannons, 500);
    return () => clearTimeout(timer);
  }, []);

  const scrollToAbout = () => {
    const el = document.querySelector("#about");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-screen flex items-end overflow-hidden" style={{ background: "#ffffff" }}>
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="/white-gradient-1.avif"
          alt="Background"
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[87.5rem] mx-auto px-10 pb-12 md:pb-20 pt-28 md:pt-40">
        {/* Event Label */}
        <div className="mb-8">
          <span
            className="inline-block text-[#6b7280] text-xs font-medium uppercase tracking-[0.2em] mb-4"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            A Walker Ottawa Event
          </span>
        </div>

        {/* Main Headline */}
        <h1
          className="text-[#FE3A80] uppercase leading-[0.76] mb-8"
          style={{
            fontFamily: "'Montserrat', Arial, sans-serif",
            fontWeight: 900,
            fontSize: "clamp(3rem, 3.5rem + 2.5vw, 6rem)",
            maxWidth: "15ch",
          }}
        >
          Built to Lead
        </h1>

        {/* Subtitle */}
        <p
          className="text-[#1f2937] text-lg md:text-xl font-medium leading-relaxed max-w-2xl mb-10"
          style={{ fontFamily: "'Inter', Arial, sans-serif" }}
        >
          {siteData.tagline}
        </p>

        {/* Event Meta */}
        <div className="flex flex-wrap items-center gap-6 mb-8 md:mb-12">
          <div className="flex items-center gap-2 text-[#6b7280]">
            <Calendar size={16} className="text-[#FE3A80]" />
            <span className="text-sm font-medium" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              {siteData.date} &middot; {siteData.time}
            </span>
          </div>
          <a
            href="https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUqDQgBEC4YrwEYxwEYgAQyCggAEEUYFhgeGDkyDQgBEC4YrwEYxwEYgAQyBwgCEAAYgAQyBwgDEAAYgAQyCAgEEAAYFhgeMggIBRAAGBYYHjIICAYQABgWGB4yCAgHEAAYFhgeMggICBAAGBYYHtIBCDM1OTFqMGo3qAIAsAIA&um=1&ie=UTF-8&fb=1&gl=ca&sa=X&geocode=KQEAAASqBc5MMe-h3NlgfxTY&daddr=245+Centrum+Blvd,+Orl%C3%A9ans,+ON+K1E+0A1"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[#6b7280] hover:text-[#FE3A80] transition-colors"
          >
            <MapPin size={16} className="text-[#FE3A80]" />
            <span className="text-sm font-medium underline" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              {siteData.location}
            </span>
          </a>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-wrap gap-4 mb-10 md:mb-16">
          <a
            href="/gallery"
            className="inline-flex items-center justify-center bg-[#FE3A80] text-[#ffffff] border-none rounded-[10rem] px-8 py-4 text-sm font-semibold uppercase cursor-pointer transition-transform duration-300 hover:scale-[1.02] active:scale-[0.98] no-underline"
            style={{ fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "-0.04em" }}
          >
            View Gallery
          </a>
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={scrollToAbout}
          className="flex items-center gap-2 bg-transparent border-none text-[#6b7280] cursor-pointer group transition-colors duration-300 hover:text-[#FE3A80]"
        >
          <ArrowDown size={16} className="animate-bounce" />
          <span className="text-xs uppercase tracking-[0.15em] font-medium" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            Discover More
          </span>
        </button>
      </div>
    </section>
  );
};
